export const config = {
  portfolio: {
    portfolioLogo: "Portfolio",
    projectCard: {
      cards: [
        {
          heading: " Background Remover using React",
          description:
            "Developed Background Remover App with React where used Animated Css .",
          animationDelay: "300",
          buttonLink: "https://background-removerashiq.vercel.app/",
          buttonText: "CHECK OUT",
        },
         {
          heading: " REAL ESTATE By Ashiq",
          description:
            "Created a modern, fully responsive real estate landing page using React, Vite, and Framer Motion with smooth animations .",
          animationDelay: "300",
          buttonLink: "https://real-estate-byashiq.vercel.app",
          buttonText: "CHECK OUT",
        },
        {
          heading: " E-commerce WebApp using React",
          description:
            "Developed an intuitive e-commerce platform featuring core functionalities such as Add to Bag, Remove from Bag, auto-calculation of cart totals, and seamless navigation through the checkout process.",
          animationDelay: "300",
          buttonLink: "https://shopping-website-gu31.vercel.app/",
          buttonText: "CHECK OUT",
        },
        
        {
          heading: "Chat Application",
          description:
            "Created Chat Application using React and Firebase which is totally real time chat application .",
          animationDelay: "300",
          buttonLink: "https://react-chat-app-ashiq.vercel.app",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Company Website",
          description:
            "During my Internship I proposed a company website for Tumpat Solutions",
          animationDelay: "300",
          buttonLink: "https://ashiq33.github.io/tumpatsolutions.com/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Al Quran(EN VERS)",
          description: "Created AL QURAN WEB APP using react.js in my learning phase",
          animationDelay: "900",
          buttonLink: "https://al-quran-en.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Blood Donation",
          description:
            "A Blood donation project using PHP which will help to find blood in emergency situation,",
          animationDelay: "500",
          buttonLink: "http://bloodbyashiq.42web.io",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Attendance Management System",
          description:
            "Build an company Attendance Management System using Laravel Framework,where Companies can use Biometric fingerprint to collect attendance for employee,",
          animationDelay: "700",
          buttonLink:
            "https://ashiq33.github.io/portfolio/attendancessystem.lovestoblog.com",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Clock By React",
          description: "Created this app using React in my Learning Phase,",
          animationDelay: "900",
          buttonLink:
            "https://ashiq-s-clock-git-master-md-ashiq-shahariars-projects.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Social Media",
          description: "Created Social Media Web App using React+Vite and used demo json api,during my learning phase",
          animationDelay: "900",
          buttonLink: "https://socialmediabyashiq.vercel.app/",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Under Construction",
          description: "</>",
          animationDelay: "1100",
          buttonText: "",
        },
      ],
    },
    internships: {
      internship: [
        {
          companyName: "Tumpat Solutions",
          role: "Software Engineer",
          introText: "",
          duration: "02/02/2024 - 31/05/2024",
          keyPointOne: "Built a front-end  website for Tumpat Solutions",
          keyPointTwo:
            "Learned Autocad 2d and used it to draw Roadmap and also maintain other Office works using Microsoft 365",
          keyPointThree:
            "Worked with telecommunications team very closely. Gathered Team-work and Leadership ability. ",
          offsetValue: "0",
        },
        
        
      ],
    },
  },
};

export default config;
